import React, { Component } from 'react';
import logo from '../../assets/images/logo.png';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';

import './Home.css';

class Home extends Component {
    
    render() {
        return (
            <div className="page home">
                <div className="home__title">حفظ یار</div>
                <div className="home__subtitle">دوست شما برای حفظ قرآن</div>
                <div className="home__logo">
                    <span className="home__loading-bar"></span>
                    <img className="home__logo-image" src={logo} alt="logo" />
                </div>
                <RaisedButton label="حفظ بپرس" onClick={this.props.goToPage.bind(this, 'select-scope')} primary={true} style={{transform: 'scale(1.3)'}} />
                {/* <FlatButton label="مرور کن" secondary={true} style={{marginTop: '.8em'}} /> */}
                <a className="home__website-link" href="http://hefzyar.web.app" target="_blank">hefzyar.web.app</a>
            </div>
        );
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home/Home.jsx